export default "<p>uploads-wizard works!</p>\nHERE ARE THE UPLOADS!!!"